import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

export type FastServicePackageSelect = {
	OsobniCis?: string;
	PracovnikOzn?: string;
	ProvozovnaId?: number;
	PracovnikId?: number;
	PracovnikText?: string;
	ProvozovnaIdText?: number;
};

class AudatexProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}
}

export const apiProvider = new AudatexProvider();
